export const prices = [
  {
    _id: 0,
    name: "Under Rs. 499",
    array: [0, 499],
  },
  {
    _id: 1,
    name: "Under Rs. 1999",
    array: [0, 1999],
  },
  {
    _id: 2,
    name: "Under Rs. 9999",
    array: [0, 9999],
  },
  {
    _id: 3,
    name: "Under - Rs. 1 Lakh",
    array: [0, 100000],
  },
];
